export default "__VITE_ASSET__CbdVpDP3__"